import { BuildingUserConstants, BuildingUserReducer, BuildingUserActionTypes } from './types';

export const buildingUserReducerInitialState = {
  buildingUsers: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  validInviteInformation: undefined,
  inviteAccepted: false,
  userScopes: [],
  isLoading: false,
  inviteCreated: false,
  successMessage: '',
  error: '',
};

export function buildingUserReducer(
  state: BuildingUserReducer = buildingUserReducerInitialState,
  action: BuildingUserActionTypes,
) {
  switch (action.type) {
    case BuildingUserConstants.SetBuildingUsers:
      return {
        ...state,
        buildingUsers: action.payload,
        isLoading: false,
      };
    case BuildingUserConstants.CreateUserInvite:
      return {
        ...state,
        inviteCreated: true,
        isLoading: false,
      };
    case BuildingUserConstants.ReceiveValidInvite:
      return {
        ...state,
        validInviteInformation: action.payload,
        isLoading: false,
      };
    case BuildingUserConstants.InviteAccepted:
      return {
        ...state,
        inviteAccepted: true,
      };
    case BuildingUserConstants.StartLoading:
      return {
        ...state,
        isLoading: true,
      };
    case BuildingUserConstants.SetUserScopes:
      return {
        ...state,
        userScopes: action.payload,
        isLoading: false,
      };
    case BuildingUserConstants.SetUserActionSuccess:
      return {
        ...state,
        successMessage: action.payload,
        isLoading: false,
      };
    case BuildingUserConstants.ClearUserActionSuccess:
      return {
        ...state,
        successMessage: '',
      };
    case BuildingUserConstants.SetBuildingUserError:
      return {
        ...state,
        error: action.payload,
      };
    case BuildingUserConstants.ClearBuildingUserError:
      return {
        ...state,
        error: '',
      };
    default:
      return state;
  }
}
